import { useIsSellerFeatureEnabled } from '../../../hooks/use-is-seller-feature-enabled';
import { SellerFeatures } from '../../../enums/seller-features';
import { useBrandedTrackingFeatureGate } from '../../../feature-gates/use-branded-tracking-feature-gate';
import { useIsSellerOnFeatureGatedPlan } from '../../../feature-gates/use-is-seller-on-feature-gated-plan';

// hasEnhancedFeatures means the seller has access to new layouts and promo image
// hasBaseFeatures means the seller has access to the basic branding inputs like logo, colors, etc.
export const useIsBrandingTrackingEnabledForSeller = () => {
  const isOnNewLineup = useIsSellerOnFeatureGatedPlan();
  const { isFeatureEnabled } = useBrandedTrackingFeatureGate();
  const sellerHasFeature = useIsSellerFeatureEnabled(SellerFeatures.BrandedTracking);

  if (isOnNewLineup) {
    return {
      hasEnhancedFeatures: isFeatureEnabled,
      hasBaseFeatures: isFeatureEnabled,
    };
  }

  return { hasEnhancedFeatures: sellerHasFeature, hasBaseFeatures: true };
};
